import { z } from "zod";

import { requiredString } from "@/common/components/forms/schema";
import { PASSWORD_MIN_LENGTH } from "@/shared/constants/password.constants";

const newPasswordSchema = z.object({
  password: requiredString().min(
    PASSWORD_MIN_LENGTH,
    "reset.password.length.error",
  ),
});

type NewPasswordFormValues = z.infer<typeof newPasswordSchema>;

const NEW_PASSWORD_INITIAL_VALUES: NewPasswordFormValues = {
  password: "",
};

export {
  newPasswordSchema,
  NEW_PASSWORD_INITIAL_VALUES,
  type NewPasswordFormValues,
};
